import React from 'react';
import PropTypes from 'prop-types';

const SectionLoader = ({ label = 'Section' }) => (
  <div className="section-loader" role="status" aria-live="polite">
    <span className="section-loader__spinner" aria-hidden="true" />
    <span className="section-loader__text">{label} loading...</span>
  </div>
);

SectionLoader.propTypes = {
  label: PropTypes.string
};

export default SectionLoader;
